import getApi from '@web/helpers/api'

import {ApiLogData} from './interfaces'

export async function postLog({pageSet, entry, code, level = 'INFO', state, message, info, type}: ApiLogData) {
    const baseUrl = `${process.env['REACT_APP_API_BASE_PATH'] || process.env['NEXT_PUBLIC_API_BASE_PATH']}/universal`

    try {
        await getApi(baseUrl).post('/log', {
            code,
            state,
            level,
            message,
            pageSet,
            entry,
            info,
            ...(type ? {type} : {}),
        })
    } catch {
        /**
         * log 호출중 사용자 로그인 문제나 apigw, nelo 오류가 발생하더라도 앱 자체는 영향이 없어야하므로 외부로 error throw 하지 않는다
         */
    }
}
